import type {
  BookingTripConflict,
  CancelWorkshopBookingInput,
  MoveWorkshopBookingInput,
  NextFreeWindowView,
  Page,
  TruckScheduleEntry,
  WorkshopBookingListQuery,
  WorkshopBookingView,
} from '@chukua/common';
import { toListParams } from '../../../../shared/policies/list-params';
import { api } from '../../../../shared/shared.api';

export type { BookingTripConflict, NextFreeWindowView, TruckScheduleEntry, WorkshopBookingView };

/** What the forms send: dates as ISO strings, since `JSON.stringify` of a `Date` is the same thing. */
export interface CreateWorkshopBookingBody {
  truckId: string;
  garageId?: string;
  isInHouse: boolean;
  startsAt: string;
  endsAt: string;
  confirmConflicts: boolean;
}

export type MoveWorkshopBookingBody = Omit<MoveWorkshopBookingInput, 'startsAt' | 'endsAt'> & { startsAt: string; endsAt: string };

export function listWorkshopBookings(query: WorkshopBookingListQuery): Promise<Page<WorkshopBookingView>> {
  return api<Page<WorkshopBookingView>>(`/workshop-bookings?${toListParams(query)}`);
}

export function getTruckSchedule(truckId: string, range: { from: Date; to: Date }): Promise<TruckScheduleEntry[]> {
  const params = new URLSearchParams({ from: range.from.toISOString(), to: range.to.toISOString() });
  return api<TruckScheduleEntry[]>(`/trucks/${truckId}/schedule?${params}`);
}

export function createWorkshopBooking(body: CreateWorkshopBookingBody): Promise<WorkshopBookingView> {
  return api<WorkshopBookingView>('/workshop-bookings', { method: 'POST', body: JSON.stringify(body) });
}

export function moveWorkshopBooking(id: string, body: MoveWorkshopBookingBody): Promise<WorkshopBookingView> {
  return api<WorkshopBookingView>(`/workshop-bookings/${id}/move`, { method: 'POST', body: JSON.stringify(body) });
}

export function cancelWorkshopBooking(id: string, input: CancelWorkshopBookingInput): Promise<WorkshopBookingView> {
  return api<WorkshopBookingView>(`/workshop-bookings/${id}/cancel`, { method: 'POST', body: JSON.stringify(input) });
}

export function findNextFreeWindow(truckId: string, input: { durationMinutes: number; dueBy: string }): Promise<NextFreeWindowView> {
  return api<NextFreeWindowView>(`/trucks/${truckId}/next-free-window`, { method: 'POST', body: JSON.stringify(input) });
}
